import type { SVGProps } from 'react';

export const GoBackIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='15'
    height='14'
    viewBox='0 0 15 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.5003 7.00024C12.5003 7.11628 12.4543 7.22756 12.3722 7.3096C12.2902 7.39165 12.1789 7.43774 12.0628 7.43774H3.49386L6.68488 10.6282C6.72552 10.6689 6.75777 10.7171 6.77977 10.7702C6.80177 10.8233 6.81309 10.8803 6.81309 10.9377C6.81309 10.9952 6.80177 11.0522 6.77977 11.1053C6.75777 11.1584 6.72552 11.2066 6.68488 11.2473C6.64423 11.2879 6.59597 11.3202 6.54286 11.3422C6.48975 11.3642 6.43283 11.3755 6.37534 11.3755C6.31786 11.3755 6.26094 11.3642 6.20783 11.3422C6.15472 11.3202 6.10646 11.2879 6.06581 11.2473L2.12831 7.30977C2.08764 7.26914 2.05537 7.22089 2.03335 7.16778C2.01133 7.11467 2 7.05774 2 7.00024C2 6.94275 2.01133 6.88582 2.03335 6.83271C2.05537 6.7796 2.08764 6.73134 2.12831 6.69071L6.06581 2.75321C6.14791 2.67112 6.25925 2.625 6.37534 2.625C6.49144 2.625 6.60278 2.67112 6.68488 2.75321C6.76697 2.8353 6.81309 2.94665 6.81309 3.06274C6.81309 3.17884 6.76697 3.29018 6.68488 3.37227L3.49386 6.56274H12.0628C12.1789 6.56274 12.2902 6.60884 12.3722 6.69088C12.4543 6.77293 12.5003 6.88421 12.5003 7.00024Z'
      fill='#8E8E8E'
    />
  </svg>
);
